import React, { useState } from "react";
import { motion } from 'framer-motion';
import { toast } from 'react-toastify';
import { obtenerParticipacionesProveedor } from "../services/solicitudesService";

export default function ParticipacionesProveedor() {
  const [cedula, setCedula] = useState("");
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const mostrarDato = dato => (dato === null || dato === undefined || dato === "" || dato === 0) ? <span className="fst-italic text-muted">&lt;No indicado&gt;</span> : dato;

  const buscar = async () => {
    setLoading(true);
    setError(null);
    setResult(null);
    try {
      // Consultar todos los proveedores
  const res = await fetch('/APIbridge/proveedores');
      const proveedores = await res.json();
      const existe = proveedores.some(p => p.cedulaJuridica === cedula);
      if (!existe) {
        setResult('no-existe');
        toast.error('Proveedor no existe.', { autoClose: 3000 });
        setLoading(false);
        return;
      }
      // Buscar participaciones
      let data = null;
      try {
        data = await obtenerParticipacionesProveedor(cedula);
      } catch {
        data = [];
      }
      if (!data || (Array.isArray(data) && data.length === 0)) {
        setResult([]);
        toast.info('Datos no encontrados.', { autoClose: 2500 });
      } else {
        setResult(data);
        toast.success('Participaciones cargadas correctamente.', { autoClose: 2000 });
      }
    } catch (err) {
      setResult(null);
      toast.error('Hubo un error al consultar el proveedor o las participaciones.', { autoClose: 3000 });
    } finally {
      setLoading(false);
    }
  };

  return (
  <motion.div className="container my-5" initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
      <h2 className="mb-4 text-primary">Participaciones por Proveedor</h2>
      <div className="input-group mb-3">
        <input className="form-control" placeholder="Cédula jurídica" value={cedula} onChange={e => setCedula(e.target.value)} />
        <button className="btn btn-primary" onClick={buscar}>Buscar</button>
      </div>
      {loading && <div className="alert alert-info">Buscando...</div>}
      {error && <div className="alert alert-danger">{error}</div>}
      <div>
        {Array.isArray(result) ? (
          result.length ? (
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Consecutivo de Oficio</th>
                  <th>Título</th>
                </tr>
              </thead>
              <tbody>
                {result.map((r, i) => (
                  <motion.tr key={i} whileHover={{ scale: 1.03, backgroundColor: '#e3f2fd' }} transition={{ type: 'spring', stiffness: 300 }}>
                    <td>{mostrarDato(r.consecutivoOficioSolicitud)}</td>
                    <td>{mostrarDato(r.tituloSolicitud)}</td>
                  </motion.tr>
                ))}
              </tbody>
            </table>
          ) : (
            <span className="text-muted">Datos no encontrados.</span>
          )
        ) : (result === 'no-existe' ? <span className="text-danger">Proveedor no existe.</span> : null)}
      </div>
  </motion.div>
  );
}
